import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface LoginAttempt {
  email: string;
  ipAddress: string;
  success: boolean;
  loginType: 'manual' | 'auto'; // 수동 로그인 vs 세션 자동 로그인
  timestamp: any;
  errorCode?: string;
  errorMessage?: string;
  userAgent?: string;
}

/**
 * 로그인 시도 정보를 Firestore에 기록합니다.
 */
export const logLoginAttempt = async (
  email: string,
  ipAddress: string,
  success: boolean,
  loginType: 'manual' | 'auto' = 'manual',
  errorCode?: string,
  errorMessage?: string
): Promise<void> => {
  try {
    const loginAttemptsRef = collection(db, 'loginAttempts');

    const attemptData: LoginAttempt = {
      email,
      ipAddress,
      success,
      loginType,
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
    };

    if (!success && errorCode) {
      attemptData.errorCode = errorCode;
      attemptData.errorMessage = errorMessage;
    }

    await addDoc(loginAttemptsRef, attemptData);
  } catch (error) {
    console.error('Failed to log login attempt:', error);
    // 로깅 실패해도 로그인 프로세스는 계속 진행
  }
};
